import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { Modal, message, notification } from 'antd';
import { getAdminErrorDisplay } from '@/utils/admin';
import {
  adminLoginPath,
  getAdminToken,
  shouldSilenceAuthError,
} from '@/utils/admin-session';

interface ResponseStructure {
  code: number;
  message: string;
  data: any;
  request_id?: string;
}

export const errorConfig: RequestConfig = {
  errorConfig: {
    errorThrower: (res) => {
      const { code, data, message: errorMessage } =
        res as unknown as ResponseStructure;
      if (code !== 0) {
        const error: any = new Error(errorMessage);
        error.name = 'BizError';
        error.info = { errorCode: code, errorMessage, data };
        throw error;
      }
    },
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (error.name === 'BizError') {
        const errorInfo:
          | { errorCode?: number; errorMessage?: string; data?: any }
          | undefined = error.info;

        if (errorInfo?.errorCode === 40101) {
          const pathname = window.location.pathname;
          const hasToken = Boolean(getAdminToken());
          localStorage.removeItem('admin_token');

          if (shouldSilenceAuthError(pathname)) {
            return;
          }

          if (hasToken) {
            message.error('登录状态已失效，请重新登录');
          }

          window.location.href = adminLoginPath;
          return;
        }

        const display = getAdminErrorDisplay(
          errorInfo?.errorCode,
          errorInfo?.errorMessage || '请求失败',
        );

        if (display.type === 'dialog') {
          Modal.error({
            title: `错误码 ${errorInfo?.errorCode ?? 'UNKNOWN'}`,
            content: display.message,
          });
          return;
        }

        notification.error({
          message: `错误码 ${errorInfo?.errorCode ?? 'UNKNOWN'}`,
          description: display.message,
        });
        return;
      }

      if (error.response) {
        message.error(`请求失败：${error.response.status}`);
      } else if (error.request) {
        message.error('服务未响应，请稍后重试');
      } else {
        message.error('请求异常，请稍后重试');
      }
    },
  },
  requestInterceptors: [
    (config: RequestOptions) => {
      const token = getAdminToken();
      const headers = {
        ...config.headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      };
      return { ...config, headers };
    },
  ],
};
